import axios from 'axios';
import base from '@/api/base.api';
const namespace = 'cards/api-v1';

export default {
    hasPendingCommissionAmount: (paymentSourceId) => {
        return axios.post(`${base.baseUrlWallet}/${namespace}/check-minimum-deposit`, {paymentSourceId}).then(({data: {object}}) => object);
    },
}
